<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('sirc requests')"
      :columns="columns"
      :column_search="true"
      resource_url="/sirc/request/datatables"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/sirc/settings' })"
        >
          <span class="icon"><i class="fa fa-users"></i></span>
          <span>{{ $t("profiles") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <sirc-request-modal ref="sirc_request_modal" @success="refresh" />
    <log-modal ref="log_modal" />
    <detail-modal ref="detail_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  put,
  error_message,
  base64_to_pdf,
  format_date_time,
} from "@/utils";
import SircRequestModal from "../sirc_request_modal/Index.vue";
import LogModal from "../log_modal/Index.vue";
import DetailModal from "../detail_modal/Index.vue";
import { truncate } from "lodash";
import sirc_request_types from "../../sirc_request_types.json";

export default {
  name: "SIRCRequestsDatatable",
  components: { GenericTable, SircRequestModal, LogModal, DetailModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          width: "25%",
          data: (row) => {
            return `<div class="title is-6">${v.$t("process")} ${
              row.sirc_process_number
            } - ${v.translate_status(row.status_code)}</div>
             <div class="subtitle is-6">${format_date_time(
               row.create_date
             )}</div>`;
          },
        },
        // {
        //   title: v.$t("status"),
        //   searchable: false,
        //   width: "30%",
        //   data: (row) => {
        //     return `${v.$t("process")} ${
        //       row.sirc_process_number
        //     } - ${v.translate_status(row.status_code)}`;
        //   },
        // },
        {
          title: v.$t("data"),
          searchable: false,
          data: (row) => {
            return row.data || "";
          },
        },
        {
          title: v.$t("response"),
          searchable: false,
          data: (row) => {
            return row.json_response || "";
          },
        },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.log_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.detail_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("execute"),
                icon: "fa fa-bolt",
                icon_class: "is-small has-text-warning",
                click: function (e) {
                  confirm_deletion_dialog(
                    v.$t("are you sure to execute sirc request?"),
                    v,
                    () => {
                      put("/sirc/request/execute", { uuid: row.uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete request?"),
                    v,
                    () => {
                      del("/sirc/request", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            if (["16"].includes(row.sirc_process_number)) {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("download"),
                icon: "fa fa-download",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  get("/sirc/request/download", { uuid: row.uuid })
                    .then((response) => {
                      let base64_pdf = response;
                      base64_to_pdf(base64_pdf, "sirc_request.pdf");
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                  // console.log("edit order", e.detail.uuid);
                },
              });
            }

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    create() {
      let v = this;
      v.$refs.sirc_request_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    translate_status(status) {
      let v = this;
      switch (status) {
        case "C":
          return v.$t("created");
        case "P":
          return v.$t("processed");
        case "E":
          return v.$t("errored");
        default:
          return status;
      }
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
